import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import TitleHeader from "./titleHeader";
import Step from "../Components/FormElements/step";
import useBeforeFirstRender from '../customHook/useBeforFirstRender';
import BeneficiaryForm from "../Components/beneficiaryForm";
import iconAdd from "../Resources/svg/icon-add.svg";
import { addBeneficiary } from "../Store/simulate/actions";
import { capitalize } from '../Utils/validators';


export default function Beneficiaries() {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const data = useSelector(state => state.simulate.policy.client);
  const beneficiariesData = useSelector(state => state.simulate.policy.beneficiary);
  const client = data.datosCliente
  const history = useHistory();
  const beneficiaryDefault = {
    tipoDoc: '2',
    documento: '',
    relacion: '',
    porcentaje: '',
    nombres: '',
    apePaterno: '',
    apeMaterno: '',
  };
  // exists beneficiaries in redux
  const initData = () => {
    if (beneficiariesData.length > 0) {
      return beneficiariesData;
    } else {
      return [beneficiaryDefault];
    }
  };
  const initErrors = () => {
    if (beneficiariesData.length > 0) {
      return beneficiariesData.map(() => false);
    } else {
      return [true];
    }
  };
  const [beneficiaries, setBeneficiaries] = useState(initData());
  const [totalPercentageBeneficiaries, setTotalPercentageBeneficiaries] = useState(beneficiariesData.length === 0 ? 0 : 100);
  const [errors, setErrors] = useState(initErrors());
  const [existsErrors, setExistsErrors] = useState(beneficiariesData.length === 0);
  const [errorMessage, setErrorMessage] = useState('');

  const navigationPrev = () => {
    history.push('/simulaciones/declaracion-de-salud');
  };

  const navigationNext = () => {
    const beneficiariesData = beneficiaries.map(elem => {
      const item = elem;
      item.nombres = capitalize(elem.nombres);
      item.apePaterno = capitalize(elem.apePaterno);
      item.apeMaterno = capitalize(elem.apeMaterno);
      return item;
    });
    dispatch(addBeneficiary(beneficiariesData));
    history.push('/simulaciones/info-complementaria-1');
  };

  const addItemBeneficiary = (e) => {
    e.preventDefault();
    if (existsErrors) {
      return false;
    }
    if (validBeneficiariesLimit() >= 100) {
      return false;
    }
    if (beneficiaries.length > 5) {
      setErrorMessage('Solo puede agregar como máximo 6 beneficiarios.')
      return false;
    } else {
      setErrorMessage('')
    }
    setBeneficiaries(beneficiaries.concat(beneficiaryDefault));
    setErrors(errors.concat(true));
    setExistsErrors(true);
  };

  const updateBeneficiary = (value, index, errorFields) => {
    beneficiaries[index] = value;
    setBeneficiaries(beneficiaries);
    errors[index] = errorFields;
    setErrors(errors);
    setExistsErrors(errors.filter(value => value === true).length > 0);
    validBeneficiariesLimit();
  };

  const removeBeneficiary = index => {
    beneficiaries.splice(index, 1);
    setBeneficiaries(beneficiaries);

    let clonErrors = [...errors];
    clonErrors.splice(index, 1);
    setErrors(clonErrors);
    setExistsErrors(errors.filter(value => value === true).length > 0);
    validBeneficiariesLimit();
  };

  const validBeneficiariesLimit = () => {
    let sum = 0;
    beneficiaries.forEach(elem => {
      sum += parseFloat(elem.porcentaje) || 0;
    });
    setTotalPercentageBeneficiaries(sum);
    return sum;
  };

  const setChecked = (val) => {
    const beneficiaries = val ? [] : [beneficiaryDefault];
    setIsChecked(val);
    setBeneficiaries(beneficiaries);
    dispatch(addBeneficiary(beneficiaries));
  };

  useBeforeFirstRender(client);

  return (
    <div className="container">
      <div className="beneficiaries">
        <Step handleClick={() => navigationPrev()} step="4" total="7"/>
        <TitleHeader 
          title="Sus"
          titleBold="beneficiarios"
          subtitle="Ingresa sus datos y el porcentaje asignado"
        />
        <div className="beneficiaries__section">
          <div className="column">
            <div className="title">Usar beneficiarios legales:</div>
            <div className="description">Acepta como beneficiarios a aquellos designados por la ley cómo hijos, cónyuge, padres, etc.</div>
          </div>
          <div className="column-checkbox">
            <label>
              <input 
                type="checkbox"
                name="isCheckLegal"
                className="filled-in"
                checked={isChecked}
                onChange={() =>  setChecked(!isChecked)}
              />
              <span></span>
            </label>
          </div>
        </div>
        {!isChecked && 
          <div className="contentBeneficiaries">
            <div className="title">Personalizar beneficiarios:</div>
            {beneficiaries.map((beneficiary, index) => (
              <BeneficiaryForm
                key={index}
                beneficiary={beneficiary}
                index={index}
                updateBeneficiary={updateBeneficiary}
                removeBeneficiary={removeBeneficiary}
                count={beneficiaries.length}
                existsErrors={existsErrors}
              />
            ))}
            <a 
              href="#" 
              className="lnkAdd"
              onClick={(e) => addItemBeneficiary(e)}
            >
              <img src={iconAdd}/> 
              <span>Agregar beneficiario</span>
            </a>
            {(existsErrors || errorMessage) !== '' && 
              <p className="error">{errorMessage !== '' ?  errorMessage : 'Todos los campos son obligatorios.'}</p>
            }
            {totalPercentageBeneficiaries >= 100 && 
              <p className="error">Ya no puede agregar más beneficiarios, el límite total de porcentaje es 100%.</p>
            }
          </div>
        }
        <button
          type="button" 
          className="buttonCustom md"
          disabled={isChecked ? false : (existsErrors || totalPercentageBeneficiaries !== 100)}
          onClick={() => navigationNext()}>
          Continuar
        </button>
      </div>
    </div>
  );
}